// GTM integration with Turbo navigation
// Ensures page_view events are tracked correctly during Turbo navigation
let pageViewTimeout = null;
let isInitialLoad = true;

document.addEventListener('turbo:load', () => {
  // Skip the first turbo:load on initial page load since GTM already tracked it
  if (isInitialLoad) {
    isInitialLoad = false;
    return;
  }
  
  // Clear any pending page view events
  if (pageViewTimeout) {
    clearTimeout(pageViewTimeout);
  }
  
  // Debounce the page view event to prevent duplicates
  pageViewTimeout = setTimeout(() => {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'turbo_page_view',
        'page_path': window.location.pathname,
        'page_title': document.title,
        'page_location': window.location.href
      });
    }
  }, 100);
});
